'use strict';
/**
 * @author Romatel
 */
import angular from 'angular';
import OperationTypeController from './controller/operationType';
import OperationTypeSelectController from './controller/operationTypeSelect';
import OperationTypeModalCreateController from './controller/operationTypeModalCreate';
import OperationTypeModalSelectController from './controller/operationTypeModalSelect';
import OperationTypeTable from './directive/operationTypeTable';
import OperationTypeService from './service/operationType';

export default angular.module('investmentProject.operationType', [])
    .controller('OperationTypeController', OperationTypeController)
    .controller('OperationTypeModalCreateController', OperationTypeModalCreateController)
    .controller('OperationTypeModalSelectController', OperationTypeModalSelectController)
    .controller('OperationTypeSelectController', OperationTypeSelectController)
    .directive('operationTypeTable', OperationTypeTable)
    .factory('OperationTypeService', OperationTypeService)
    .name;
